import { inject, Injectable } from '@angular/core';
import { RecaptchaService } from '@principle-theorem/ng-shared';
import {
  IConfirmGapOfferData,
  IConfirmGapOfferRequest,
  PATIENT_PORTAL_DISPATCHER,
  PatientAction,
  PatientActionRequest,
} from '@principle-theorem/principle-core/interfaces';
import {
  httpsCallable,
  SerialisedData,
  snapshot,
  unserialise,
} from '@principle-theorem/shared';

@Injectable()
export class PatientGapOfferService {
  private _recaptcha = inject(RecaptchaService);

  async resolveGapOfferData(
    tokenUid: string
  ): Promise<IConfirmGapOfferData | undefined> {
    try {
      const payload = {
        action: PatientAction.GetPatientGapOffer,
        data: { tokenUid },
        recaptchaToken: await this._recaptcha.execute(
          PatientAction.GetPatientGapOffer
        ),
      };

      const response = await snapshot(
        httpsCallable<
          PatientActionRequest<IConfirmGapOfferRequest>,
          SerialisedData<IConfirmGapOfferData>
        >(PATIENT_PORTAL_DISPATCHER)(payload)
      );

      return unserialise(response);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error resolving gap offer data:', e);
      return undefined;
    }
  }
}
